import * as React from "react";
import { connect } from "react-redux";
import get from "lodash/get";

import {
  LastShopifyReward as LastShopifyRewardComponent,
  LastShopifyRewardProps,
} from "../../components/LastShopifyReward/LastShopifyReward";
import {
  accountCreditReverse,
  getShopifyActiveDiscounts as getShopifyActiveDiscountsAction,
  getShopifyActiveGiftCards as getShopifyActiveGiftCardsAction,
  pollForRewardReversal,
} from "../../actions";
import { StoreState } from "../../reducers";
import {
  getRewardRequestStatus,
  getShopifyActiveDiscounts,
  getShopifyActiveGiftCards,
} from "../../reducers/methods";

interface LastShopifyRewardContainerProps extends LastShopifyRewardProps {
  accountCreditReverse: typeof accountCreditReverse;
  getShopifyActiveDiscountsAction: typeof getShopifyActiveDiscountsAction;
  getShopifyActiveGiftCardsAction: typeof getShopifyActiveGiftCardsAction;
  pollForRewardReversal: typeof pollForRewardReversal;
  requestStatus: ReturnType<typeof getRewardRequestStatus>;
  shopifyActiveDiscounts: ReturnType<typeof getShopifyActiveDiscounts>;
  shopifyActiveGiftCards: ReturnType<typeof getShopifyActiveGiftCards>;
}

class LastShopifyReward extends React.Component<LastShopifyRewardContainerProps> {
  componentDidMount() {
    const isCustomerAuthenticated = get(
      this.props.data,
      "customer.authenticated",
      false
    );

    if (isCustomerAuthenticated) {
      this.getRewards();
    }
  }

  getRewards = () => {
    const {
      rewardType,
      requestStatus,
      getShopifyActiveDiscountsAction,
      getShopifyActiveGiftCardsAction,
    } = this.props;

    if (
      rewardType === "shopifyDiscount" &&
      requestStatus.getShopifyActiveDiscounts !== "REQUESTING"
    ) {
      getShopifyActiveDiscountsAction();
    }

    if (
      rewardType === "shopifyGiftCard" &&
      requestStatus.getShopifyActiveGiftCards !== "REQUESTING"
    ) {
      getShopifyActiveGiftCardsAction();
    }
  };

  render() {
    return <LastShopifyRewardComponent {...this.props} />;
  }
}

const mapStateToProp = (state: StoreState) => ({
  requestStatus: getRewardRequestStatus(state),
  shopifyActiveDiscounts: getShopifyActiveDiscounts(state),
  shopifyActiveGiftCards: getShopifyActiveGiftCards(state),
});

export default connect(mapStateToProp, {
  accountCreditReverse,
  getShopifyActiveDiscountsAction,
  getShopifyActiveGiftCardsAction,
  pollForRewardReversal,
})(LastShopifyReward);
